import { useParams, useLocation, Link } from 'react-router-dom';
import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';

import ProjectSelect from './Projects/ProjectSelect';
import UserDropdown from './User/UserDropdown';
import SampleSearchAutocomplete from './Samples/SampleSearchAutocomplete'

function ResponsiveAppBar(props) {
    const params = useParams();
    const {
      pathname
    } = useLocation();

    const {
        projects, 
        activeProject,
        reloadProjects,
        setActiveProject,
        onActiveProjectChange, 
        userData, 
        organization, 
        setSamples, 
        datasetsGridRef,
        setShowDocs,
        isProjectSelectionReady,
    } = props;

    let projectSelectContent = null;
    let sampleSearchContent = null;
    if (!params.sampleId && pathname !== '/profile') {
        projectSelectContent = (
            <ProjectSelect
            projects={projects}
            reloadProjects={reloadProjects}
            organizationId={organization?.id}
            activeProject={activeProject}
            isProjectSelectionReady={isProjectSelectionReady}
            onActiveProjectChange={onActiveProjectChange}
            setActiveProject={setActiveProject}
            />
        );

        sampleSearchContent = (
            <SampleSearchAutocomplete
            activeProject={activeProject}
            setSamples={setSamples} 
            datasetsGridRef={datasetsGridRef}
            hasAccessReportViruses={organization?.attributes?.metadata?.FF_report_viruses}
            />
        );
    }

    return (
        <AppBar position="static" sx={{ backgroundColor: 'white', boxShadow: 'none', borderBottom: '#bdbdbd 2px solid' }}>
          <Container maxWidth="xl">
            <Toolbar disableGutters>
              <Box sx={{ padding: '0 40px 0 0' }}>
              <Link to="/">
                <img 
                  height="80px"
                  src="/ceph_logo.png" 
                  alt="cep-logo" 
                  style={{ cursor: 'pointer' }}
                />
              </Link>
              </Box>

              <Box sx={{ padding: '15px 20px 15px 0', minWidth: '150px' }}>
                {projectSelectContent}
              </Box>

              <Box sx={{ flexGrow: 1, display: { xs: 'flex' }, padding: '15px 20px 15px 0' }}>
                {sampleSearchContent}
              </Box>

              <Box sx={{ flexGrow: 0, paddingRight: 2 }}>
                <h3 style={{color: 'gray', fontWeight: 'normal'}}><span style={{fontWeight: "bold"}}>{userData?.data.attributes.name}</span> | {organization?.attributes.name}{' '}
              </h3>
              </Box>

              <Box sx={{ flexGrow: 0 }}>
                <UserDropdown setShowDocs={setShowDocs} />
              </Box>
            </Toolbar>
          </Container>
        </AppBar>
    );
}

export default ResponsiveAppBar;
